export default {
  read: 'Lido',
  unread: 'Não lido',
  title: 'Alertas',
  subtitle: 'Eventos de cerca, bateria e dispositivo.',
  mark_read: 'Marcar como lido',
  mark_all_read: 'Marcar todos como lidos',
  empty: 'Nenhum alerta por aqui.',
  empty_hint: 'Alertas de cercas e dispositivos aparecem nesta lista.',
  unread_only: 'Não lidos',
  all: 'Todos',
  at: 'em',
  observed_at: 'Observado {time}',
  notified_at: 'aviso {time}',
  new: 'Novo',
  content_unavailable: 'Este conteúdo não está mais disponível para você.',
  kind_all: 'Todos os tipos',
  kind_geofence_transition: 'Cercas',
  kind_stale_sighting: 'Sinal parado',
  kind_low_battery: 'Bateria',
  kind_delivery: 'Entregas',
  kind_activation: 'Ativação',
  kind_mock_location: 'Localização simulada',
  kind_impossible_travel: 'Deslocamento impossível',
  kind_device_tamper: 'Sabotagem',
  kind_sim_changed: 'Troca de SIM',
  kind_consent_expired: 'Consentimento vencido',
  page_of: 'Página {page} de {total}',
  rules_title: 'Regras de alerta',
  rules_hint: 'Canais de aviso por tipo, para toda a conta. Regra inativa silencia o tipo inteiro.',
  rule_active: 'Ativo',
  channel_in_app: 'No app',
  channel_push: 'Push',
  channel_email: 'E-mail',
  threshold_label: 'Avisar com bateria abaixo de',
  stale_label: 'Avisar após minutos sem posição',
  prefs_title: 'Minhas preferências',
  prefs_hint: 'Valem só para você: podem desligar canais, nunca ligar o que a conta desligou.',
  prefs_general: 'Todos os tipos',
  prefs_custom: 'Personalizado',
  prefs_reset: 'Restaurar padrão',
  saved: 'Salvo',
}
